import { AnswerAreaPinComponent, LayoutPart, Size, Vector } from '../../models';
import { newBox, newSize, newVector } from '../geometry';
import { defaultOrder } from '../order';
import { randomId } from '../random-id';

type AnswerAreaPinComponentProps = {
  position?: Vector;
  size?: Size;
  backgroundColor?: string;
  transparency?: number;
  layoutPart?: LayoutPart;
  order?: string;
};

export function newAnswerAreaPinComponent({
  position = newVector(32, 124),
  size = newSize(896, 384),
  backgroundColor,
  transparency,
  order = defaultOrder,
}: AnswerAreaPinComponentProps): AnswerAreaPinComponent {
  return {
    type: 'ANSWER_AREA',
    id: randomId(),
    settings: {
      backgroundColor,
      transparency,
      lockLayout: true,
    },
    layout: newBox(position, size),
    order,
  };
}
